module.exports = __webpack_public_path__ + "img/logo_login_background.495d5358.jpeg";